
// src/actions/url-info.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_URL_INFO = "FETCH_URL_INFO"
export const FETCH_URL_INFO_REQUESTED = "FETCH_URL_INFO_REQUESTED"
export const FETCH_URL_INFO_COMPLETED = "FETCH_URL_INFO_COMPLETED"
export const FETCH_URL_INFO_FAILED = "FETCH_URL_INFO_FAILED"
export const CLEAR_URL_INFO = "CLEAR_URL_INFO"

export function fetchUrlInfoRequested(url, componentId) {
  return {
    type: FETCH_URL_INFO_REQUESTED,
    url, componentId
  }
}

export function fetchUrlInfo(url, componentId) {
  url = url.replace(/^http/i, 'http')
  if (!url.match(/^http/))
    return { type: FETCH_URL_INFO }
  return function(dispatch) {
    dispatch(fetchUrlInfoRequested(url, componentId))
    return api.get(`/url_info`, { url })
        .then((results)=> {
          dispatch(fetchUrlInfoCompleted(url, results, componentId))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchUrlInfoFailed(error, componentId, url)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchUrlInfoCompleted(url, results, componentId) {
  return {
    type: FETCH_URL_INFO_COMPLETED,
    url, results, componentId
  }
}

export function fetchUrlInfoFailed(error, componentId, url) {
  return {
    type: FETCH_URL_INFO_FAILED,
    error, componentId, url
  }
}

export function clearUrlInfo(componentId) {
  return {
    type: CLEAR_URL_INFO,
    componentId
  }
}



// WEBPACK FOOTER //
// ./src/actions/url-info.js